<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>credit_card</md-icon>
        </div>
        <h4 class="title">
          Payment Details
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>First Name on Card</label>
              <md-input
                v-model="card.card.firstName"
                v-on:input="emitDirty()"
                data-tour="first_name_on_card"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Last Name on Card</label>
              <md-input
                v-model="card.card.lastName"
                v-on:input="emitDirty()"
                data-tour="last_name_on_card"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <span>Card Number</span>
            <md-field class="card-input">
              <md-input
                v-model="card.card.number"
                :placeholder="card.card.maskedNumber"
                max-length="16"
                min-length="16"
                v-on:input="emitDirty()"
                v-on:blur="validateNumber()"
                data-tour="card_number"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-10">
            <md-field>
              <label>Expiry Month</label>
              <md-input
                v-model="card.card.expiryMonth"
                v-on:input="emitDirty()"
                type="number"
                max="12"
                min="1"
                data-tour="expiry_month"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-10">
            <md-field>
              <label>Expiry Year</label>
              <md-input
                v-model="card.card.expiryYear"
                v-on:input="emitDirty()"
                type="number"
                max="2030"
                min="2019"
                data-tour="expiry_year"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <span>Security Number (CVV)</span>
            <md-field class="card-input">
              <md-input
                v-model="card.card.securityCode"
                placeholder="***"
                v-on:input="emitDirty()"
                v-on:blur="validateCVV()"
                data-tour="security_number"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
export default {
  name: "edit-billing-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    card: {},
    ogCard: {}
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    emitDirty: function() {
      var dirty = false;
      if (this.card.card.number === "" && this.ogCard.card.number === null) {
        this.card.card.number = null;
      }
      if (
        this.card.card.firstName === "" &&
        this.ogCard.card.firstName === null
      ) {
        this.card.card.firstName = null;
      }
      if (
        this.card.card.lastName === "" &&
        this.ogCard.card.lastName === null
      ) {
        this.card.card.lastName = null;
      }
      if (
        this.card.card.expiryMonth === "" &&
        this.ogCard.card.expiryMonth === null
      ) {
        this.card.card.expiryMonth = null;
      }
      if (
        this.card.card.expiryYear === "" &&
        this.ogCard.card.expiryYear === null
      ) {
        this.card.card.expiryYear = null;
      }
      if (
        this.card.card.securityCode === "" &&
        this.ogCard.card.securityCode === null
      ) {
        this.card.card.securityCode = null;
      }
      if (
        this.card.card.firstName != this.ogCard.card.firstName ||
        this.card.card.lastName != this.ogCard.card.lastName ||
        this.card.card.expiryMonth != this.ogCard.card.expiryMonth ||
        this.card.card.expiryYear != this.ogCard.card.expiryYear ||
        this.card.card.number != this.ogCard.card.number ||
        this.card.card.securityCode != this.ogCard.card.securityCode
      ) {
        dirty = true;
      }

      this.$emit("dirty", "card", dirty);
    },
    validateNumber: function() {
      var creditCardValidator = require("card-validator");
      if (
        this.card &&
        this.card.card &&
        !this.card.card.number.includes("************")
      ) {
        var numberValidation = creditCardValidator.number(
          this.card.card.number
        );
        if (!numberValidation.isValid) {
          this.$notify({
            message:
              "The Credit Card number entered is not a valid card number",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning",
            timeout: 0
          });
        }
      }
    },
    validateCVV: function() {
      var creditCardValidator = require("card-validator");
      if (
        this.card &&
        this.card.card &&
        !this.card.card.securityCode.includes("***")
      ) {
        var threeDigitCvvValidator = creditCardValidator.cvv(this.card.card.securityCode, 3);
        var fourDigitCvvValidator = creditCardValidator.cvv(this.card.card.securityCode, 4);
        if (!threeDigitCvvValidator.isValid && !fourDigitCvvValidator.isValid) {
          this.$notify({
            message: "The CVV entered is not valid",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "top",
            type: "warning",
            timeout: 0
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.card-input {
  margin-top: 0px;
}
</style>
